document.addEventListener("DOMContentLoaded", function () {
  class YGAddCartButton extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', this.getAttribute('role') || 'button');
      this.setAttribute('tabindex', this.getAttribute('tabindex') || '0');
      this._setupLoader();
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeyDown);
    }

    _setupLoader() {
      if (this.querySelector('.button__loader')) {
        this._contentElement = this.querySelector('.yg-add-cart-button__content');
        this._loaderElement = this.querySelector('.button__loader');
        return;
      }

      const contentElement = document.createElement('span');
      contentElement.className = 'yg-add-cart-button__content';
      contentElement.append(...this.childNodes);

      const loaderElement = document.createElement('span');
      loaderElement.className = 'button__loader';
      loaderElement.innerHTML = '<span></span><span></span><span></span>';

      this.append(contentElement, loaderElement);
      this._contentElement = contentElement;
      this._loaderElement = loaderElement;
    }

    _onClick = (event) => {
      event.preventDefault();
      this._triggerQuickBuy();
    };

    _onKeyDown = (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this._triggerQuickBuy();
    };

    _triggerQuickBuy() {
      if (this.getAttribute('aria-disabled') === 'true') {
        return;
      }

      if (this.getAttribute('aria-busy') === 'true') {
        return;
      }

      const quickBuy = this.closest('product-card')?.querySelector('.product-card__quick-buy');

      if (!quickBuy) {
        return;
      }

      const form = quickBuy.querySelector('form[is="product-form"]');

      if (form) {
        this._setLoading(true);
        form.addEventListener('variant:add', () => this._setLoading(false), { once: true });
        form.addEventListener('cart:error', () => this._setLoading(false), { once: true });
        form.requestSubmit();
        return;
      }

      const quickBuyDrawer = quickBuy.querySelector('quick-buy-drawer');

      if (quickBuyDrawer) {
        this._setLoading(true);
        Promise.resolve(quickBuyDrawer.show()).finally(() => this._setLoading(false));
        return;
      }

      quickBuy.querySelector('button, [aria-controls]')?.click();
    }

    _setLoading(isLoading) {
      this.toggleAttribute('aria-busy', isLoading);

      if (isLoading) {
        this._animateLoading();
      } else {
        this._animateIdle();
      }
    }

    _animateLoading() {
      this._contentElement?.animate(
        { transform: ['translateY(0)', 'translateY(-10px)'], opacity: [1, 0] },
        { duration: 150, fill: 'forwards' }
      );

      this._loaderElement?.animate(
        { transform: ['translateY(10px)', 'translateY(0)'], opacity: [0, 1] },
        { duration: 150, fill: 'forwards' }
      );

      this._loaderElement?.querySelectorAll('span').forEach((dot, index) => {
        dot.animate(
          { opacity: [1, 0.1] },
          { duration: 350, delay: index * (350 / 3), direction: 'alternate', iterations: Infinity }
        );
      });
    }

    _animateIdle() {
      this._loaderElement?.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());

      this._loaderElement?.animate(
        { transform: ['translateY(0)', 'translateY(-10px)'], opacity: [1, 0] },
        { duration: 150, fill: 'forwards' }
      );

      this._contentElement?.animate(
        { transform: ['translateY(10px)', 'translateY(0)'], opacity: [0, 1] },
        { duration: 150, fill: 'forwards' }
      );
    }
  }

  if (!window.customElements.get('yg-add-cart-btn')) {
    window.customElements.define('yg-add-cart-btn', YGAddCartButton);
  }
})
